/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { CustomerDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Create Customer
 */
export const postCustomer = (
  customerDto: CustomerDto,
  signal?: AbortSignal,
) => {
  return customInstance<CustomerDto>({
    url: `/customer`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: customerDto,
    signal,
  });
};

export const getPostCustomerMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomer>>,
    TError,
    { data: CustomerDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomer>>,
  TError,
  { data: CustomerDto },
  TContext
> => {
  const mutationKey = ["postCustomer"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomer>>,
    { data: CustomerDto }
  > = (props) => {
    const { data } = props ?? {};

    return postCustomer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomer>>
>;
export type PostCustomerMutationBody = CustomerDto;
export type PostCustomerMutationError = void;

/**
 * @summary Create Customer
 */
export const usePostCustomer = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomer>>,
      TError,
      { data: CustomerDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomer>>,
  TError,
  { data: CustomerDto },
  TContext
> => {
  const mutationOptions = getPostCustomerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Customer
 */
export const putCustomerId = (id: number, customerDto: CustomerDto) => {
  return customInstance<CustomerDto>({
    url: `/customer/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: customerDto,
  });
};

export const getPutCustomerIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCustomerId>>,
    TError,
    { id: number; data: CustomerDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCustomerId>>,
  TError,
  { id: number; data: CustomerDto },
  TContext
> => {
  const mutationKey = ["putCustomerId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCustomerId>>,
    { id: number; data: CustomerDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putCustomerId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCustomerIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCustomerId>>
>;
export type PutCustomerIdMutationBody = CustomerDto;
export type PutCustomerIdMutationError = void;

/**
 * @summary Update Customer
 */
export const usePutCustomerId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putCustomerId>>,
      TError,
      { id: number; data: CustomerDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putCustomerId>>,
  TError,
  { id: number; data: CustomerDto },
  TContext
> => {
  const mutationOptions = getPutCustomerIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find Customer By Id
 */
export const getCustomerId = (id: number, signal?: AbortSignal) => {
  return customInstance<CustomerDto>({
    url: `/customer/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetCustomerIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/customer/${id}`] as const;
};

export const getGetCustomerIdQueryKey = (id?: number) => {
  return [`/customer/${id}`] as const;
};

export const getGetCustomerIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getCustomerId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCustomerId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerId>>> = ({
    signal,
  }) => getCustomerId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCustomerId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCustomerIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerId>>
>;
export type GetCustomerIdInfiniteQueryError = void;

export function useGetCustomerIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCustomerId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCustomerId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomerIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCustomerId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCustomerId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomerIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCustomerId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCustomerId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Customer By Id
 */

export function useGetCustomerIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCustomerId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCustomerId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCustomerIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCustomerIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCustomerIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerId>>> = ({
    signal,
  }) => getCustomerId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCustomerIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerId>>
>;
export type GetCustomerIdQueryError = void;

export function useGetCustomerId<
  TData = Awaited<ReturnType<typeof getCustomerId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomerId<
  TData = Awaited<ReturnType<typeof getCustomerId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomerId<
  TData = Awaited<ReturnType<typeof getCustomerId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Customer By Id
 */

export function useGetCustomerId<
  TData = Awaited<ReturnType<typeof getCustomerId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCustomerIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete Customer
 */
export const deleteCustomerId = (id: number) => {
  return customInstance<boolean>({ url: `/customer/${id}`, method: "DELETE" });
};

export const getDeleteCustomerIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomerId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomerId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteCustomerId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomerId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCustomerId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCustomerIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomerId>>
>;

export type DeleteCustomerIdMutationError = void;

/**
 * @summary Delete Customer
 */
export const useDeleteCustomerId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCustomerId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomerId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteCustomerIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find Customer By Name
 */
export const getCustomerNameName = (name: string, signal?: AbortSignal) => {
  return customInstance<CustomerDto>({
    url: `/customer/${name}/name`,
    method: "GET",
    signal,
  });
};

export const getGetCustomerNameNameInfiniteQueryKey = (name?: string) => {
  return ["infinite", `/customer/${name}/name`] as const;
};

export const getGetCustomerNameNameQueryKey = (name?: string) => {
  return [`/customer/${name}/name`] as const;
};

export const getGetCustomerNameNameInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getCustomerNameName>>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCustomerNameName>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerNameNameInfiniteQueryKey(name);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerNameName>>
  > = ({ signal }) => getCustomerNameName(name, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!name,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCustomerNameName>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCustomerNameNameInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerNameName>>
>;
export type GetCustomerNameNameInfiniteQueryError = void;

export function useGetCustomerNameNameInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCustomerNameName>>>,
  TError = void,
>(
  name: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCustomerNameName>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerNameName>>,
          TError,
          Awaited<ReturnType<typeof getCustomerNameName>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomerNameNameInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCustomerNameName>>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCustomerNameName>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerNameName>>,
          TError,
          Awaited<ReturnType<typeof getCustomerNameName>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomerNameNameInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCustomerNameName>>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCustomerNameName>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Customer By Name
 */

export function useGetCustomerNameNameInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCustomerNameName>>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCustomerNameName>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCustomerNameNameInfiniteQueryOptions(
    name,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCustomerNameNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerNameName>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerNameName>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerNameNameQueryKey(name);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerNameName>>
  > = ({ signal }) => getCustomerNameName(name, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!name,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerNameName>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCustomerNameNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerNameName>>
>;
export type GetCustomerNameNameQueryError = void;

export function useGetCustomerNameName<
  TData = Awaited<ReturnType<typeof getCustomerNameName>>,
  TError = void,
>(
  name: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerNameName>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerNameName>>,
          TError,
          Awaited<ReturnType<typeof getCustomerNameName>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomerNameName<
  TData = Awaited<ReturnType<typeof getCustomerNameName>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerNameName>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerNameName>>,
          TError,
          Awaited<ReturnType<typeof getCustomerNameName>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomerNameName<
  TData = Awaited<ReturnType<typeof getCustomerNameName>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerNameName>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Customer By Name
 */

export function useGetCustomerNameName<
  TData = Awaited<ReturnType<typeof getCustomerNameName>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerNameName>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCustomerNameNameQueryOptions(name, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
